<div class="px-4 py-5 my-5 text-center">
  <h1 style="color: var(--secondary-color)" class="display-5 fw-bold ">¿Tienes alguna duda?</h1>
  <div class="col-lg-6 mx-auto">
    <p style="color: var(--secondary-color)" class="display-6 lead mb-4">Contáctanos al:</p>
  </div>

  <div class="container text-center mw-50">
    <div class="row align-items-center">

      <div class="d-grid gap-2 d-sm-flex flex-column justify-content-sm-center" *ngFor="let item of sucursales ">
        <h4 type="button" class="buttonAction text-light  mx-auto"><i style="color: var(--terciary-color)" class="bi bi-telephone-fill "></i> {{ item.numberPhone }}</h4>
        <h4 type="button" class="buttonAction text-light  mx-auto"><i style="color: var(--terciary-color)" class="bi bi-whatsapp "></i>
          <a target="_blank" class="text-light" href="https://wa.me/593993183975" > 0993183975 </a></h4>


      </div>

    </div>

    <div class="row align-items-center">

      <div class="d-grid gap-3 py-2 d-sm-flex  justify-content-sm-center align-items-center">
        <h4 type="button" class="buttonAction text-light  mx-auto"><i style="color: var(--terciary-color)" class="bi bi-envelope"></i>
          <a class="text-light" href="mailto: contactcenter@medilink.com.ec "> contactcenter&#64;medilink.com.ec</a> </h4>
        <h4 type="button" class="buttonAction text-light  mx-auto"><i style="color: var(--terciary-color)" class="bi bi-envelope "></i>
          <a class="text-light" href="mailto: comercial@medilink.com.ec "> comercial&#64;medilink.com.ec</a> </h4>


      </div>

      <div class="d-grid gap-2 d-sm-flex flex-column justify-content-sm-center" *ngFor="let item of sucursales ">

        <h4  type="button" class="fs-5 text-center px-4 gap-3"><i style="color: var(--terciary-color)" class="bi bi-geo-alt-fill"></i> {{ item.name }}</h4>

      </div>

    </div>

  </div>

</div>
